const getCurrentActionOrigin = (): string | undefined => {
    if (typeof window === 'undefined') return undefined;
    return window.location.origin;
};

export default getCurrentActionOrigin;
